export default {
    dbi_twitch_channels: 'Twitch Channel',
    dbi_youtube_channels: 'Youtube Channel',
    dbi_facebook_channels: 'Facebook Channel',
    dbi_Primary_games: 'Primary Games',
    dbi_Primary_hours_watched: 'Hours Watched',
    dbi_Primary_peak: 'Peak Concurrent Viewership',
    dbi_Primary_avg: 'Avg Concurrent Viewership',
    dbi_Primary_airtime: 'Airtime',
    dbi_Primary_Key_metrics: 'Key Metrics',
    dbi_Primary_stream_metrics: 'Stream Metrics',
    dbi_Primary_channel: 'Primary Channel',
    dbi_Primary_kol: 'Influencer',
    dbi_streaming_twitch: 'Twitch',
    dbi_streaming_youtube: 'YouTube',
    dbi_streaming_facebook_gaming: 'Facebook Gaming',
    dbi_streaming_language_country: 'Language/Country',
    dbi_streaming_channel_url: 'Channel URL',
    dbi_Primary_disabled_messages1: 'This filter is only available when the platform is  Twitch only',
    dbi_Primary_disabled_messages2: 'This filter is only available when the platform is  YouTube only',

}